<template>
    <li role="treeitem" :aria-expanded="ariaExpanded">
        <span :class="[
            ariaExpanded ? ariaExpandedClass : ariaCollapsedClass,
            selectedSourceId === category.source_id ? 'fancytree-active' : ''
        ]">
            <span
                v-if="category.children_count > 0 && !fetchingStarted"
                role="button"
                class="fancytree-expander"
                @click="toggleCategory"
            ></span>
            <i v-else-if="category.children_count > 0 && fetchingStarted" class="icon-spinner2 spinner"></i>
            <span class="fancytree-title" @click="category.children_count === 0 && toggleCategorySelection()">{{ category.name_uk }}</span>
        </span>
        <ul role="group" v-if="category.children_count > 0">
            <CategoryTreeItemComponent
                v-for="child in children"
                :category="child"
                :targetIntegrationService="targetIntegrationService"
                :selectedSourceId="selectedSourceId"
                @update:selectedCategory="$emit('update:selectedCategory', $event)"
            />
        </ul>
    </li>
</template>
<script>
import { httpClient } from '../../../../services/HttpClient';

export default {
    name: 'CategoryTreeItemComponent',
    props: {
        category: {
            type: Object,
            required: true
        },
        targetIntegrationService: {
            type: String,
            required: true
        },
        selectedSourceId: {
            type: Number,
            default: null
        }
    },
    emits: ['update:selectedCategory'],
    data() {
        return {
            ariaExpanded: false,
            ariaExpandedClass: 'fancytree-node fancytree-expanded fancytree-has-children fancytree-exp-e fancytree-ico-ef',
            ariaCollapsedClass: 'fancytree-node fancytree-has-children fancytree-exp-c fancytree-ico-cf',
            children: [],
            fetchingStarted: false
        }
    },
    methods: {
        toggleCategory() {
            this.ariaExpanded = !this.ariaExpanded;

            if (this.ariaExpanded) {
                this.fetchChildren();
            } else {
                this.children = [];
            }
        },
        toggleCategorySelection() {
            this.$emit('update:selectedCategory', this.category);
        },
        async fetchChildren() {
            this.fetchingStarted = true;

            await httpClient.get(`/projects/${this.$route.params.projectUuid}/marketplace/sources/${this.targetIntegrationService}/categories`, {
                parent_source_id: this.category.source_id,
                limit: this.category.children_count,
                orders: [
                    {column : 'name_uk', dir : 'asc'}
                ]
            }).then(response => {
                this.children = response.data.data;
            });

            this.fetchingStarted = false;
        }
    }
}
</script>